"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.at = void 0;
var at = function (array, pos) {
    if (pos < 0 || array.length <= pos)
        return undefined;
    return array[pos];
};
exports.at = at;
